export enum GameState {
    Idle = 0,
    Betting, //betting state, with count
    Started, //init card dealing
    Ready, //as betting, no count
    Insurance,
    InsuranceEnd,
    Decision, // = main game play, card dealing & decision & decision follow
    DecisionEnd,
    ShowDealerSecondCard,
    DealerResult, // = dealer card dealing
    PlayerHit,
    FollowDecision,
    BetTicketing,
    DecisionTicketing,
    GameResult = 0x7000,
    Shuffle = 0x7fff,
}

export enum GameSubState {
    None, // SubState = iota  // 0
    PlayerHand1, //1
    PlayerHand2, //2
}
